// extracted by mini-css-extract-plugin
export default {"inputBox":"UserPasswordForm_inputBox__t+AjY","button":"UserPasswordForm_button__mNb+A"};